import { render, staticRenderFns } from "./DomainPrivateWhoisDisableModal.vue?vue&type=template&id=3366ca44&"
import script from "./DomainPrivateWhoisDisableModal.vue?vue&type=script&lang=js&"
export * from "./DomainPrivateWhoisDisableModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../partner/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports